import CartView from './CartViewPage';

export default CartView;
